import React, { useEffect, useState } from "react";
import '../../../../Login.css';
import bg1 from '../../../media/bg-01.jpg';
import BaseUrl from "../../../utils/BaseUrl";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const url = BaseUrl();
function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading,setLoading] = useState(false);
  const [isAuthToken, setIsAuthToken] = useState(localStorage.getItem('_token_'));


  useEffect(()=>{
    if(isAuthToken !== null){
      navigate('/');
    }
},[isAuthToken]);


  const handleLogin = async (e) => {
    e.preventDefault();


    setLoading(true);
    if (!username || !password) {
      setError("Email ou mot de passe vide!");
      return;
    }
    const _formData = new FormData();
    _formData.append('email',username);
    _formData.append('password',password);
    try {
      await axios.post(url.base+'/login',_formData,{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${isAuthToken}`
              
          },
          credentials:'include'
      }
      ).then((resp)=>{
          setLoading(false);
          if(resp.status == 200){                  
              localStorage.setItem('_token_',resp.data.access_token);
              navigate('/approvisionnements');
              window.location.reload();
          }
      })
  } catch (error) {

    setLoading(false);
      if (error?.response?.status == 401) {
        setError(error?.response.data.error);
      }else{
        setError("Un problème est subvenu !");
      }
  }
    // setError("");
  };

  return (
    <>
      <div className="limiter">
        <div
          className="container-login100"
          style={{
            backgroundImage: `url(${bg1})`,
          }}
        >

          <div className="wrap-login100 p-t-30 p-b-50">
          {error && <div className="error">{error}</div>}

            <span className="login100-form-title p-b-41 p-2 border pb-2 bg-light text-center">DISTRIFORCE REPORTING</span>
            <form className="login100-form validate-form p-b-33 p-t-5" onSubmit={handleLogin}>
              <div className="wrap-input100 validate-input">
                <input
                  className="input100 border mt-3"
                  type="email"
                  name="username"
                  placeholder="Adresse e-mail"
                  value={username}
                  required
                  onChange={(e) => setUsername(e.target.value)}
                />
                <span className="focus-input100" data-placeholder="&#xe82a;"></span>
              </div>

              <div className="wrap-input100 validate-input">
                <input
                  className="input100 border"
                  type="password"
                  name="pass"
                  placeholder="Mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span className="focus-input100" data-placeholder="&#xe80f;"></span>
              </div>


              <div className="container-login100-form-btn m-t-32">
              {!loading && <button type="submit" className="login100-form-btn">
                  Connectez-vous ici !
                </button>}
                {loading &&
                               <button type="button" class="btn btn-primary login100-form-btn" disabled>
                                <div class="d-flex justify-content-center p-0">
                                  <div class="spinner-border p-0" role="status">
                                    {/* <span class="visually-hidden p-0">Loading...</span> */}
                                  </div>
                                </div>
                            </button>
                           }
              </div>
            </form>
          </div>
        </div>
      </div>

      <div id="dropDownSelect1"></div>
    </>
  );
}

export default Login;
